import { TableColumnMeta } from "ds/components/Table/types";

export enum PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS {
  SPACE = "space",
  PERMISSIONS = "permissions",
  DESCRIPTION = "description",
}

import {
  PersonalSettingsSpacesGroup,
  PersonalSettingsSpacesTableGroupMeta,
} from "./usePersonalSettingsSpacesGroupsStore/types";

export type PersonalSettingsSpacesRenderGroupRowProps = {
  row: PersonalSettingsSpacesGroup;
  columns: TableColumnMeta[];
  groupMeta: PersonalSettingsSpacesTableGroupMeta | undefined;
};

export type PersonalSettingsSpacesRenderItemRowProps = {
  row: PersonalSettingsSpacesGroup;
  columns: TableColumnMeta[];
};
